import { c as _c } from "react/compiler-runtime";
import { ADVISOR_TEAM_PRODUCT_ID, STARTUPS_PRO_PRODUCT_ID } from '../intent';
import { productRenewalLabel } from '../presentation';
import { useConversionProducts } from './useConversionProducts';

/** "Startups Pro ($49/mo)" when priced, the bare plan name while loading or unpriced. */
export function withPrice(name: string, price?: string | null) {
  return price ? `${name} (${price})` : name;
}

/**
 * Monthly renewal prices of the membership ladder from the live catalog, for copy that names
 * them. Values are null until the catalog answers, so copy must read without them.
 */
export function usePlanPriceLabels() {
  const $ = _c(11);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [STARTUPS_PRO_PRODUCT_ID, ADVISOR_TEAM_PRODUCT_ID];
    t1 = {
      termId: "month"
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const {
    products
  } = useConversionProducts(t0, t1);
  let t2;
  if ($[2] !== products) {
    t2 = productId => {
      const product = products.find(candidate => candidate.productId === productId);
      return product ? productRenewalLabel(product) : null;
    };
    $[2] = products;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const label = t2;
  let t3;
  if ($[4] !== label) {
    t3 = label(STARTUPS_PRO_PRODUCT_ID);
    $[4] = label;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== label) {
    t4 = label(ADVISOR_TEAM_PRODUCT_ID);
    $[6] = label;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = {
      pro: t3,
      team: t4
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}